import React, {useRef, useEffect} from "react";
import Fileinput from "@/components/ui/Fileinput";

export interface FileInputEvent {
    previewURL: string
    file: File|undefined
}
export interface FileInputOptions {
    file: File|undefined
    label: string
    className: string
    onChange: (e :FileInputEvent) => void
}
const FileInputPreview = (props: FileInputOptions) => {
    const [file, setFile] = React.useState(props.file);

    const [inputID, setInputID] = React.useState(Date.now);
    let objectURL : any = null;

    return (
        <div className={props.className}>
            <label className="block capitalize form-label">
                {props.label}
            </label>
            {/*@ts-ignore*/}
            <Fileinput
                onDeleteClick={!file ? undefined : () => {
                    setFile(undefined)
                    setInputID(Date.now())
                    props.onChange({
                        file : undefined,
                        previewURL : ''
                    })
                }}
                key={inputID}
                name="basic"
                selectedFile={file}
                onChange={(e: any) => {
                    if (!e.target.files || e.target.files.length === 0) {
                        setFile(undefined)
                        props.onChange({
                            file : undefined,
                            previewURL : ''
                        })
                        return
                    }

                    let file =e.target.files[0]
                    objectURL = URL.createObjectURL(file)
                    setFile(file)
                    props.onChange({
                        file : file,
                        previewURL : objectURL
                    })
                }}
            />
        </div>
    )
}

export default FileInputPreview;